export default __webpack_public_path__ + "static/media/QiDao-red.7daf9e93.svg";